import {
  Component,
  Input,
  QueryList,
  ContentChildren,
  AfterContentInit,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { CignaIcon } from '@cigna/shared/angular/icon-ui';
import { SlidingTabComponent } from '../sliding-tab/sliding-tab.component';
import { WindowService } from '@cigna/shared/angular/core/window-util';

@Component({
  selector: 'cigna-sliding-tabs-group',
  templateUrl: './sliding-tabs-group.component.html',
  styleUrls: ['./sliding-tabs-group.component.scss'],
})
export class SlidingTabsGroupComponent implements AfterContentInit {
  CignaIcon = CignaIcon;

  focusedTabIndex: number;
  mobileWidthThreshhold = 768;
  isFirstTabOutOfViewport: boolean;
  isLastTabOutOfViewport: boolean;

  tabRefsArray: Array<ElementRef<any>>;
  tabsArray: SlidingTabComponent[];

  @Input() title: string;

  @Input() shouldFocusTab = true;

  @Input() ariaLabelText?: string;
  @Input() ariaOwnsIds?: string;

  @ContentChildren(SlidingTabComponent, { read: ElementRef })
  slidingTabRefs: QueryList<ElementRef>;

  @ContentChildren(SlidingTabComponent)
  slidingTabs = new QueryList<SlidingTabComponent>();

  constructor(
    public elem: ElementRef,
    private _window: WindowService,
    private renderer: Renderer2,
  ) {}

  ngAfterContentInit() {
    this.tabsArray = this.slidingTabs.toArray();
    this.tabRefsArray = this.slidingTabRefs.toArray();
    this.isLastTabOutOfViewport = this.tabsArray.length > 2;

    this.focusedTabIndex = this.getActiveTabIndex();
    if (this.shouldFocusTab) {
      this.tabRefsArray[this.focusedTabIndex].nativeElement.focus();
      if (this._window.innerWidth <= this.mobileWidthThreshhold) {
        this.scrollTabs(this.focusedTabIndex);
      }
    }

    this.renderer.listen(
      this.elem.nativeElement.querySelector('.tabs-container'),
      'scroll',
      () => {
        const firstTabCoordinates =
          this.tabRefsArray[0].nativeElement.getBoundingClientRect();
        const lastTabCoordinates =
          this.tabRefsArray[
            this.tabRefsArray.length - 1
          ].nativeElement.getBoundingClientRect();

        this.isFirstTabOutOfViewport = firstTabCoordinates.x < 0;
        this.isLastTabOutOfViewport =
          lastTabCoordinates.right - 10 > this._window.innerWidth;
      },
    );
  }

  scrollTabs(index: number) {
    if (index < this.tabRefsArray.length && index >= 0) {
      this.focusedTabIndex = index;
    }
    this.tabRefsArray[this.focusedTabIndex].nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: index === this.tabRefsArray.length - 1 ? 'start' : 'center',
    });
  }

  getActiveTabIndex(): number {
    return this.tabsArray.findIndex((tab) => tab.isActive);
  }
}
